import type { FailureReason } from '@Application/Security/TokenJourney/FailureReason';
import ApiError from '@Infra/FetchLib/ApiError';

/**
 * The only place in the front that reads an HTTP status code. `410` covers expiration, consumption
 * and revocation alike: the server distinguishes them by its message, never by its status. Anything
 * that is not an `ApiError` — a network failure, for instance — resolves to `unknown`.
 */
const resolveFailureReason = (error: unknown): FailureReason => {
	if (!(error instanceof ApiError)) {
		return 'unknown';
	}

	switch (error.status) {
		case 404: {
			return 'not-found';
		}
		case 410: {
			return 'gone';
		}
		case 400: {
			return 'invalid';
		}
		default: {
			return 'unknown';
		}
	}
};

export default resolveFailureReason;
